import React, { useEffect, Suspense, lazy } from 'react';
import { initMetaPixel } from './metaPixel';
import { initUtmify } from './utmify';
import { Hero } from './components/Hero';
// Below-the-fold sections are code-split so the hero + CTA paint instantly.
const PainPoints = lazy(() => import('./components/PainPoints').then(m => ({
  default: m.PainPoints
})));
const Solution = lazy(() => import('./components/Solution').then(m => ({
  default: m.Solution
})));
const Volumes = lazy(() => import('./components/Volumes').then(m => ({
  default: m.Volumes
})));
const LookInside = lazy(() => import('./components/LookInside').then(m => ({
  default: m.LookInside
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const Benefits = lazy(() => import('./components/Benefits').then(m => ({
  default: m.Benefits
})));
const SpecialOffer = lazy(() => import('./components/SpecialOffer').then(m => ({
  default: m.SpecialOffer
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const Testimonials = lazy(() => import('./components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const LastChance = lazy(() => import('./components/LastChance').then(m => ({
  default: m.LastChance
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
function SectionFallback() {
  return <div className="min-h-[40vh]" aria-hidden="true" data-id="element-0" />;
}
export function App() {
  useEffect(() => {
    initMetaPixel();
    initUtmify();
  }, []);
  return <div className="min-h-screen bg-navy-950 font-sans text-slate-300 selection:bg-gold-500/30 selection:text-gold-200" data-id="element-1">
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Suspense fallback={<SectionFallback data-id="element-5" />} data-id="element-4">
          <PainPoints data-id="element-6" />
          <Solution data-id="element-7" />
          <Volumes data-id="element-8" />
          <LookInside data-id="element-9" />
          <Bonuses data-id="element-10" />
          <Benefits data-id="element-11" />
          <SpecialOffer data-id="element-12" />
          <Guarantee data-id="element-13" />
          <Testimonials data-id="element-14" />
          <FAQ data-id="element-15" />
          <LastChance data-id="element-16" />
        </Suspense>
      </main>
      <Suspense fallback={<SectionFallback data-id="element-18" />} data-id="element-17">
        <Footer data-id="element-19" />
      </Suspense>
    </div>;
}